export default __webpack_public_path__ + "icon9c2efa.svg";